// import services from '@/helpers/services.js'
// import { Message } from 'element-ui'
function getAccessToken () {
  const idToken = window.localStorage.getItem('token')
  if (idToken) {
    return idToken
  } else {
    return null
  }
}

export {
  getAccessToken
}
